module.exports = __webpack_public_path__ + "static/media/mask@3x.9448c855.png";